import { createFeatureSelector, createSelector } from '@ngrx/store';
import { domainsAdapter, DomainsState, domainFeatureKey } from './domains.state';
import { SiteDomainStatus, UserDomain } from '../../synaps-media.types';

export const selectDomainsState = createFeatureSelector<DomainsState>(domainFeatureKey);

const { selectAll, selectEntities } = domainsAdapter.getSelectors();

export const selectAllDomains = createSelector(
  selectDomainsState,
  selectAll
);

export const selectDomainEntities = createSelector(
  selectDomainsState,
  selectEntities
);

export const selectDomainsLoading = createSelector(
  selectDomainsState,
  (state) => state.loading
);

export const selectDomainsCreating = createSelector(
  selectDomainsState,
  (state) => state.loadingCreate
);

export const selectDomainsError = createSelector(
  selectDomainsState,
  (state) => state.error
);

export const selectSelectedDomainId = createSelector(
  selectDomainsState,
  (state) => state.selectedDomainId
);

export const selectSelectedDomain = createSelector(
  selectDomainEntities,
  selectSelectedDomainId,
  (domainEntities, domainId) => domainId ? domainEntities[domainId] : null
);

export const selectActiveDomains = createSelector(
  selectAllDomains,
  (domains) => domains.filter(domain => domain.status === SiteDomainStatus.ACTIVE)
);

export const selectWaitingConfigurationDomains = createSelector(
  selectAllDomains,
  (domains) => domains.filter(domain => domain.status === SiteDomainStatus.WAITING_CONFIGURATION)
);

export const selectManagedDomains = createSelector(
  selectAllDomains,
  (domains) => domains.filter(domain => domain.managed)
);

export const selectDomainByName = (domainName: string) => createSelector(
  selectAllDomains,
  (domains) => domains.find(domain => domain.domain === domainName) || null
);
